var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReportIssueIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: 192,
    height: 192,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b2cdb61d-8fd0-4cea-81bc-aea83805356e",
    "data-name": "Talk"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.5,163.71c6.36-38.79,29.11-62.46,57.33-62.46s51,23.7,57.33,62.46",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.83,28.29h36.48a0,0,0,0,1,0,0V64.77a36.48,36.48,0,0,1-36.48,36.48h0A36.48,36.48,0,0,1,41.34,64.77v0A36.48,36.48,0,0,1,77.83,28.29Z",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.1,72.73a22.25,22.25,0,0,1,0,31.47",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,59.66a40.74,40.74,0,0,1,0,57.61",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.77,48.06a57.14,57.14,0,0,1,0,80.8",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 8
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReportIssueIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/report_issue_icon.34564e43c7d5cd089294fd1779780c56.svg";